import { styled } from "@l2r-front/l2r-ui"

export const PageContainer = styled("div")(({ theme }) => ({
    height: "100%",
    backgroundColor: theme.errorBackground,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
}))